import { useState, useEffect } from "react";

export default function useDarkMode() {
    // Set initial theme based on localStorage or default to 'light'
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

    useEffect(() => {
        const root = window.document.documentElement;

        // Remove the opposite theme class, and add the current theme class
        if (theme === "dark") {
            root.classList.remove("light");
            root.classList.add("dark");
        } else {
            root.classList.remove("dark");
            root.classList.add("light");
        }

        // Update localStorage based on theme
        localStorage.setItem("theme", theme);
    }, [theme]);

    // Toggle theme between 'dark' and 'light'
    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
    };

    // Return the current theme and function to toggle theme
    return [theme, toggleTheme];
}